import React, { useEffect, useMemo, useState } from 'react'
import { useForm, useFormContext } from 'react-hook-form';
import { closeModalAction } from '../../../actions/modal';
import { useDispatch, useSelector } from 'react-redux';
import Form from '../../../common/Form';
import FormTable from '../../../common/Form/Table';
import Input from '../../../common/Form/Input';
import Select from '../../../common/Form/Select';
import { getDefultMilestone } from '../../../actions/admin';
import { postMilestone } from '../../../actions/project';
import { actualValueForDropdown } from '../../../utils/common';

export const tasks = 'tasks';
const formName = "checklistFrom";

const inputTypeOptions = [
    { value: 'FILE', label: 'File Upload' },
    { value: 'TEXT', label: 'Text Input' },
    { value: 'SELECT', label: 'Single Select' },
    { value: 'MULTI_SELECT', label: 'Multi Select' }
];

export default function AddMileStone({ project }) {
    const { formButtonLoading } = useSelector((state) => state.loading);
    const { defaultMilestones } = useSelector((state) => state.admin)
    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(true)
    const [optionsState, setOptionsState] = useState({});

    useEffect(() => {
        dispatch(getDefultMilestone());
    }, [dispatch])

    const memoizedDefaultMilestones = useMemo(() => {
        let o = [];
        defaultMilestones?.forEach((milestone) => {
            o.push({
                key: milestone.id,
                value: milestone.type,
                label: milestone.type
            })
        })
        return o;
    }, [defaultMilestones]);


    const onMilestoneTypeChange = (selectedOption) => {

    }

    const defaultValues = {
        [tasks]: [{ id: `${Math.random()}`, options: [] }],
    };

    const methods = useForm({ defaultValues, mode: 'all' });
    const { watch, setValue } = methods

    useEffect(() => {
        const defaultTasks = defaultMilestones?.find(task => task.type === name)?.tasks;
        if (defaultTasks) {
            const sortedTasks = defaultTasks
                .map(({ title, id, input_type, options }) => {
                    let type = inputTypeOptions.find(option => option.value === input_type);
                    return { title, id, input_type: type, options: options || [] }
                })
                .sort((a, b) => a.order - b.order);
            setValue(tasks, sortedTasks);

            const initialOptionsState = {};
            sortedTasks.forEach((task, index) => {
                initialOptionsState[index] = task.options || [];
            });
            setOptionsState(initialOptionsState);
        }
    }, [defaultMilestones, setValue]);

    const onSubmit = ({ tasks, mile_stone_type }) => {

        let milestone = {
            title: 'Added Milestone',
            order: 0,
            type: actualValueForDropdown(mile_stone_type),
            tasks: tasks.map((item) => {
                return {
                    title: item.title,
                    is_file_required: false,
                    input_type: actualValueForDropdown(item.input_type),
                    options: item.options && item.options.length > 0 ? item.options : undefined
                }
            }),
            "cost": {}
        }

        dispatch(postMilestone({ projectId: project?.id, milestone, formName }))
    }

    useEffect(() => {
        const { unsubscribe } = watch((values) => {
            const fields = values?.[tasks];
            if (!fields || fields.length === 0) {
                setDisabled(true);
                return;
            }

            let isValid = true;
            for (let index = 0; index < fields.length; index++) {
                const item = fields[index];
                if (!item.title || item.title.length === 0) {
                    isValid = false;
                    break;
                }

                if (!item.input_type) {
                    isValid = false;
                    break;
                }

                if (['SELECT', 'MULTI_SELECT'].includes(item.input_type.value)) {
                    if (!optionsState[index] || optionsState[index].length === 0) {
                        isValid = false;
                        break;
                    }
                }
            }

            setDisabled(!isValid);
        });

        return () => unsubscribe();
    }, [watch, optionsState, tasks]);

    return (
        <div className="bg-white rounded-lg shadow-lg max-h-[calc(80vh-120px)] overflow-y-auto">
            <Form
                className="w-full"
                onSubmit={onSubmit}
                isLoading={formButtonLoading[formName]}
                submitButtonText="Save Milestone"
                showSubmit
                // isSubmitDisabled={disabled}
                submitContainerClassName="flex gap-3 justify-end p-4 border-t bg-gray-50 rounded-b-lg"
                methods={methods}
                onCancel={() => dispatch(closeModalAction())}
            >
                <div className="">
                    <div className='px-6 py-4'>
                        <Select
                            label='Milestone Type'
                            name='mile_stone_type'
                            options={memoizedDefaultMilestones}
                            required
                            isLoading={false}
                            onChange={onMilestoneTypeChange}
                            className="mb-4"
                        />
                    </div>
                    <MilestoneTable name={tasks} selectedMilestone={actualValueForDropdown(watch('mile_stone_type'))} />
                </div>
            </Form>
        </div>
    )
}

export const MilestoneTable = ({ name, selectedMilestone }) => {
    const [optionsState, setOptionsState] = useState({});
    const { watch, setValue } = useFormContext();
    const defaultMilestones = useSelector((state) => state.admin.defaultMilestones);

    useEffect(() => {
        const defaultTasks = defaultMilestones?.find(task => task.type === selectedMilestone)?.tasks;
        if (defaultTasks) {
            const sortedTasks = defaultTasks
                .map(({ title, id, input_type, options }) => {
                    let type = inputTypeOptions.find(option => option.value === input_type);
                    return { title, id, input_type: type, options: options || [] }
                })
                .sort((a, b) => a.order - b.order);
            setValue(name, sortedTasks);

            const initialOptionsState = {};
            sortedTasks.forEach((task, index) => {
                initialOptionsState[index] = task.options || [];
                if (task.options && task.options.length > 0) {
                    task.options.forEach((option, optionIndex) => {
                        setValue(`${name}[${index}].input_type.options[${optionIndex}]`, option.value);
                    });
                }
            });
            setOptionsState(initialOptionsState);
        }
    }, [defaultMilestones, name, selectedMilestone, setValue]);

    const addOption = (rowIndex) => {
        setOptionsState(prevState => ({
            ...prevState,
            [rowIndex]: [...(prevState[rowIndex] || []), '']
        }));
    };

    const removeOption = (rowIndex, optionIndex, event) => {
        // Prevent event propagation to avoid modal closing
        event.preventDefault();
        event.stopPropagation();

        setOptionsState(prevState => ({
            ...prevState,
            [rowIndex]: prevState[rowIndex].filter((_, index) => index !== optionIndex)
        }));
    };

    const updateOption = (rowIndex, optionIndex, value) => {
        setOptionsState(prevState => ({
            ...prevState,
            [rowIndex]: prevState[rowIndex].map((option, index) =>
                index === optionIndex ? value : option
            )
        }));
    };


    const schema = {
        table: [
            {
                head: {
                    thClassName: 'pl-4 w-full',
                    headName: 'Input Title',
                    required: true,
                },
                body: {
                    bodyClassName: 'pl-4 w-full',
                    render: (_, { rowIndex }) => (
                        <Input
                            name={`${tasks}[${rowIndex}].title`}
                            required
                            placeholder={`Enter task name`}
                            inputClassName="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-scogoprimary focus:border-transparent"
                            maxLength={40}
                        />
                    )
                },
            },
            {
                head: {
                    thClassName: 'w-[60rem] pl-4',
                    headName: 'Response Type',
                    required: true,
                },
                body: {
                    bodyClassName: 'w-[60rem] pl-4',
                    render: (_, { rowIndex }) => {
                        const inputType = watch(`${tasks}[${rowIndex}].input_type`);
                        const showOptions = ['SELECT', 'MULTI_SELECT'].includes(inputType?.value);
                        const options = optionsState[rowIndex] || [];

                        return (
                            <div className="space-y-2">
                                <RenderOption rowIndex={rowIndex} />
                                {showOptions && (
                                    <div className="mt-2 p-3 border border-gray-200 rounded-md bg-gray-50">
                                        <div className="text-sm font-medium mb-2 text-gray-700">Options</div>
                                        {options.map((option, optionIndex) => (
                                            <div key={optionIndex} className="flex items-center gap-2 mb-2">
                                                <Input
                                                    name={`${tasks}[${rowIndex}].options[${optionIndex}]`}
                                                    onChange={(e) => updateOption(rowIndex, optionIndex, e.target.value)}
                                                    placeholder={`Option ${optionIndex + 1}`}
                                                    className="flex-1"
                                                    inputClassName="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-md"
                                                    value={option.label}
                                                />
                                                <button
                                                    onClick={(e) => removeOption(rowIndex, optionIndex, e)}
                                                    className="p-1 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                                                    title="Remove option"
                                                >
                                                    <span className="material-icons text-xl">remove_circle_outline</span>
                                                </button>
                                            </div>
                                        ))}
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                addOption(rowIndex);
                                            }}
                                            className="flex items-center gap-1 text-scogoprimary hover:text-scogodarker text-sm mt-1 px-2 py-1 rounded-md hover:bg-gray-100 transition-colors"
                                        >
                                            <span className="material-icons text-xl">add_circle_outline</span>
                                            Add Option
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    }
                }
            },
            {
                head: {
                    thClassName: 'w-20 text-center',
                    headName: 'Action',
                },
                body: {
                    bodyClassName: 'w-20 text-center',
                    render: (_, { rowIndex, remove }) => (
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                remove(rowIndex);
                                // Clean up options state when removing a row
                                setOptionsState(prevState => {
                                    const newState = { ...prevState };
                                    delete newState[rowIndex];
                                    return newState;
                                });
                            }}
                            className="p-1.5 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                            title="Delete task"
                        >
                            <span className="material-icons text-xl">delete_outline</span>
                        </button>
                    ),
                },
            },
        ],
    };

    return (
        <div className="px-6 pb-6">
            <div className="mb-4">
                <h3 className="text-md font-medium text-gray-700 mb-2">Milestone Tasks</h3>
                <p className="text-sm text-gray-500">Define the tasks that need to be completed for this milestone.</p>
            </div>
            <FormTable
                isLoading={false}
                schema={schema}
                name={name}
                allowAdd
                addButtonText="Add New Task"
                addButtonClassName="mt-4 mb-2 text-sm font-medium text-scogoprimary hover:text-scogodarker flex items-center gap-2 px-3 py-1.5 border border-scogoprimary rounded-md hover:bg-scogolightblue transition-colors"
                addButtonIcon="add_circle_outline"
                tableClassName="border border-gray-200 rounded-lg overflow-hidden shadow-sm"
                tableHeadClass="bg-gray-100 shadow-sm flex px-2 py-3 text-gray-700 font-medium"
                tableBodyStyle={{ maxHeight: "calc(100vh - 400px)", overflowY: "auto" }}
                rowGenerator={() => ({ id: `${Math.random()}`, options: [] })}
            />
        </div>
    )
}



const RenderOption = ({ rowIndex }) => {
    return <Select
        name={`${tasks}[${rowIndex}].input_type`}
        options={inputTypeOptions}
        required
        placeholder="Select response type"
        className="text-sm"
    />
}
